// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Vendor floor indexing convention.
 */
export enum VendorFloorIndexing {
  ONE_BASED = 0,
  ZERO_BASED = 1,
}
